import { color } from '@thiememeulenhoff/lit-sdk';
import { ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const SCORE_LEVEL_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: color('purple', 500),
  [ScoreLevel.Unsatisfactory]: color('purple', 500),
  [ScoreLevel.Marginal]: color('orange', 500),
  [ScoreLevel.Satisfactory]: color('green', 500),
  [ScoreLevel.Excellent]: color('green', 500),
};
